import Box from "@mui/material/Box";
import logoFull from "../../assets/img/logo-full.png";
import {Alert, Button} from "@mui/material";
import {OpenInNew} from "@mui/icons-material";
import Typography from "@mui/material/Typography";

let installPrompt = null;

export default function () {

    const handleAuthClick = () => {
        window.location.replace(process.env.REACT_APP_AWS_AUTH_PAGE.replace("{clientId}", process.env.REACT_APP_AWS_CLIENT_ID).replace("{redirectUri}", process.env.REACT_APP_AWS_REDIRECT_URI));
    }


    return (
        <Box width={"100%"}>
            <Box display="flex" justifyContent="center" mt={5}>
                <img width={"90%"} src={logoFull} alt="logo"/>
            </Box>
            <Box mt={10}>
                <Alert severity="info">
                    <Typography textAlign={"center"}>Bienvenue dans l’application FAIRFAIR.</Typography>
                    <br/>
                    Utilisez les mêmes identifiants et mot de passe que votre espace dépanneur pour vous connecter.
                    <br/>
                    <br/>
                    Si vous êtes technicien, demandez à votre responsable de vous fournir les identifiants du compte
                    délégué.
                </Alert>
            </Box>

            <Box position="fixed" bottom={30} width={"100%"}>
                <Box display="flex" justifyContent="center">
                    <Button startIcon={<OpenInNew/>} variant="contained" size="large" onClick={handleAuthClick}
                            data-test="login">
                        Me connecter
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}